import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CreateUpdateParentEngagementDocumentDto,
  CreateUpdateParentEngagementDto,
  ParentEngagementDisputeDocumentDto,
  ParentEngagementDto,
} from "../../models/dispute-resolution/parent-engagement-models";

@Injectable({
  providedIn: "root",
})
export class ParentEngagementService {
  private readonly baseUrl = "/api/dispute-resolution/parent-engagement";
  private readonly partyBaseUrl = `${this.baseUrl}/parties`;
  private readonly documentBaseUrl = `${this.baseUrl}/documents`;

  constructor(private http: HttpClient) { }

  create(
    request: CreateUpdateParentEngagementDto
  ): Observable<ParentEngagementDto> {
    return this.http.post<ParentEngagementDto>(`${this.baseUrl}`, request);
  }

  getById(id: string): Observable<ParentEngagementDto> {
    return this.http.get<ParentEngagementDto>(`${this.baseUrl}/${id}`);
  }

  update(
    id: string,
    request: CreateUpdateParentEngagementDto
  ): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getAll(isEarlyDisputeResolution?: boolean): Observable<ParentEngagementDto[]> {
    const queryParam = isEarlyDisputeResolution !== undefined ? `?isEarlyDisputeResolution=${isEarlyDisputeResolution}` : '';
    return this.http.get<ParentEngagementDto[]>(`${this.baseUrl}${queryParam}`);
  }

  generateCaseNumber(isEarlyDisputeResolution: boolean): Observable<string> {
    const queryParam = isEarlyDisputeResolution ? `?isEarlyDisputeResolution=${isEarlyDisputeResolution}` : '';
    return this.http.get(
      `${this.baseUrl}/generate-case-number${queryParam}`,
      {
        responseType: "text",
      }
    );
  }

  updateCaseStatus(
    disputeCaseId: string,
    workflowStatusChangesId: string
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-case-status/${disputeCaseId}/${workflowStatusChangesId}`,
      null
    );
  }

  createDocument(
    request: CreateUpdateParentEngagementDocumentDto
  ): Observable<ParentEngagementDisputeDocumentDto> {
    return this.http.post<ParentEngagementDisputeDocumentDto>(
      `${this.documentBaseUrl}`,
      request
    );
  }

  getDocumentsByDisputeCase(
    disputeCaseId: string
  ): Observable<ParentEngagementDisputeDocumentDto[]> {
    return this.http.get<ParentEngagementDisputeDocumentDto[]>(
      `${this.documentBaseUrl}/case/${disputeCaseId}`
    );
  }

  deleteDocument(id: string): Observable<void> {
    return this.http.delete<void>(`${this.documentBaseUrl}/${id}`);
  }
}
